<template>
    <div class="about-legal-guardian-form1">
        <slot name="how-register-modal"></slot>

        <div class="lock-message" v-if="showLock">
            <LockDefault :statusLock="0" />
            <div class="text">
                Caso queira que suas informações não sejam públicas, clique no icone do cadeado para ocultar.
            </div>
        </div>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group label="Nome completo" label-for="name" class="required">
                <b-form-input
                    id="name"
                    name="name"
                    v-model="$v.form.name.$model"
                    type="text"
                    placeholder="Digite nome completo"
                    :state="validateState('name')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['nome_completo'].value)
                    "
                ></b-form-input>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['nome_completo'].value"
                />

                <b-form-invalid-feedback :state="validateState('name')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <div class="row">
                <div class="col-md-6">
                    <div class="label-created required">
                        RG/ RNE
                        <span id="rg-rne-help" class="icon-tooltip">
                            <img :src="require(`@/assets/Cadastro/responsavel/help-icon.svg`)" alt=""
                        /></span>

                        <b-tooltip target="rg-rne-help">Registro Nacional de Estrangeiros</b-tooltip>
                    </div>

                    <b-form-group>
                        <b-form-input
                            id="rg-rne"
                            name="rgRne"
                            v-model="$v.form.rgRne.$model"
                            type="text"
                            placeholder="Digite RG/ RNE"
                            :state="validateState('rgRne')"
                            :disabled="getIsDisabled"
                            v-if="
                                !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['rg'].value)
                            "
                        ></b-form-input>

                        <NoAuthorizationMsgPP
                            v-if="isPlatform && getAuthorizationData && !getAuthorizationData['rg'].value"
                        />

                        <b-form-invalid-feedback :state="validateState('rgRne')">
                            Campo obrigatório
                        </b-form-invalid-feedback>

                        <LockPP
                            :statusLock="form.rgLock"
                            :lockMsg="'Privado'"
                            :unlockMsg="'Público'"
                            @click="form.rgLock = Number(!form.rgLock)"
                            v-if="showLock"
                        />
                    </b-form-group>
                </div>

                <b-form-group label="CPF" label-for="cpf" class="col-md-6 required">
                    <b-form-input
                        id="cpf"
                        name="cpf"
                        v-model="$v.form.cpf.$model"
                        v-mask="'###.###.###-##'"
                        type="text"
                        placeholder="Digite CPF"
                        :state="validateState('cpf')"
                        :disabled="getIsDisabled"
                        v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['cpf'].value)"
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['cpf'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('cpf')">
                        <div v-if="!$v.form.cpf.required">
                            Campo obrigatório
                        </div>

                        <div v-if="!$v.form.cpf.minLength">
                            Deve conter 14 caracteres
                        </div>
                    </b-form-invalid-feedback>

                    <LockPP
                        :statusLock="form.cpfLock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.cpfLock = Number(!form.cpfLock)"
                        v-if="showLock"
                    />
                </b-form-group>
            </div>

            <div class="row">
                <b-form-group label="Data de nascimento" label-for="birthday" class="col-md-6 required">
                    <b-form-datepicker
                        id="birthday"
                        name="birthday"
                        locale="pt-br"
                        size="sm"
                        :max="getMajorityDate"
                        placeholder="Selecione uma data"
                        v-model="$v.form.birthday.$model"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :state="validateState('birthday')"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['data_nascimento'].value)
                        "
                    ></b-form-datepicker>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['data_nascimento'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('birthday')">
                        Campo obrigatório
                    </b-form-invalid-feedback>

                    <LockPP
                        :statusLock="form.birthdayLock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.birthdayLock = Number(!form.birthdayLock)"
                        v-if="showLock"
                    />
                </b-form-group>
            </div>

            <div class="row">
                <b-form-group label="Gênero" label-for="gender" class="col-md-6">
                    <b-form-select
                        id="gender"
                        name="gender"
                        v-model="form.gender.selected"
                        :options="form.gender.options"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['id_genero'].value)
                        "
                    ></b-form-select>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_genero'].value"
                    />

                    <LockPP
                        :statusLock="form.genderLock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.genderLock = Number(!form.genderLock)"
                        v-if="showLock"
                    />
                </b-form-group>

                <b-form-group label="Raça" label-for="race" class="col-md-6">
                    <b-form-select
                        id="race"
                        name="race"
                        v-model="form.race.selected"
                        :options="form.race.options"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['id_raca'].value)
                        "
                    ></b-form-select>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_raca'].value"
                    />

                    <LockPP
                        :statusLock="form.raceLock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.raceLock = Number(!form.raceLock)"
                        v-if="showLock"
                    />

                    <div>
                        <b-form-input
                            name="raceOthers"
                            style="margin-top: 20px;"
                            v-model="form.raceOthers"
                            placeholder="Especifique aqui ..."
                            :disabled="getIsDisabled"
                            v-if="form.race.selected === 5"
                        ></b-form-input>
                    </div>
                </b-form-group>
            </div>

            <div class="row">
                <b-form-group label="Celular" label-for="cell" class="col-md-6 required">
                    <b-form-input
                        id="cell"
                        name="cell"
                        v-model="$v.form.cell.$model"
                        type="text"
                        v-mask="'(##) #####-####'"
                        placeholder="Digite celular"
                        :state="validateState('cell')"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['celular'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['celular'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('cell')">
                        <div v-if="!$v.form.cell.required">
                            Campo obrigatório
                        </div>

                        <div v-if="!$v.form.cell.minLength">
                            Deve conter 15 caracteres
                        </div>
                    </b-form-invalid-feedback>

                    <LockPP
                        :statusLock="form.cellLock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.cellLock = Number(!form.cellLock)"
                        v-if="showLock"
                    />
                </b-form-group>

                <b-form-group label="E-mail" label-for="email" class="col-md-6 required">
                    <b-form-input
                        id="email"
                        name="email"
                        v-model="$v.form.email.$model"
                        type="text"
                        placeholder="Digite e-mail"
                        :state="validateState('email')"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['email'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['email'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('email')">
                        <div v-if="!$v.form.email.required">Campo obrigatório</div>
                        <div v-if="!$v.form.email.email">Escreva um e-mail válido</div>
                    </b-form-invalid-feedback>

                    <LockPP
                        :statusLock="form.emailLock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.emailLock = Number(!form.emailLock)"
                        v-if="showLock"
                    />
                </b-form-group>
            </div>

            <div class="row">
                <b-form-group label="LinkedIn" label-for="linkedin" class="col-md-12">
                    <b-form-input
                        id="linkedin"
                        name="linkedin"
                        v-model="form.linkedin"
                        type="text"
                        placeholder="insira o link do perfil"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['linkedin'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['linkedin'].value"
                    />

                    <!-- <LockPP
                        :statusLock="form.linkedinLock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.linkedinLock = Number(!form.linkedinLock)"
                        v-if="showLock"
                    /> -->
                </b-form-group>
            </div>

            <hr class="line" />

            <div class="footer-buttons">
                <slot name="platform-bottom-buttons"></slot>

                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: usuario ? 'FirstInformationForm2' : 'FirstInformationForm3' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-else>
                    <b-button :variant="'secondary'" @click="changeRegisterForm('FirstInformationForm2')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        :disabled="!getIsDisabled"
                        @click="changeRegisterForm('AboutLegalGuardianForm2')"
                    >
                        Próximo
                    </b-button>

                    <b-button
                        variant="success"
                        @click=";(isUpdate = true), onSubmit()"
                        v-if="getEditionMode && !getIsDisabled"
                    >
                        Salvar
                    </b-button>
                </div>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import LockPP from '@/ui/lock-pp/LockPP'
import { AboutLegalGuardianApi } from '../../api/register-about-legal-guardian'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import LockDefault from '@/ui/lock-default/LockDefault'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutLegalGuardianApi = new AboutLegalGuardianApi()

export default {
    components: { LockPP, DangerModalPP, LockDefault, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            progress: 11.08,
            isUpdate: false,
            legalGuardianData: null,
            usuario: null,
            isDisabled: null,
            message: null,
            authorizationData: null,
            form: {
                name: null,
                rgRne: null,
                cpf: null,
                birthday: null,
                cell: null,
                cellLock: 1,
                email: null,
                emailLock: 1,
                linkedin: null,
                linkedinLock: 1,
                rgLock: 1,
                cpfLock: 1,
                birthdayLock: 1,
                genderLock: 1,
                raceLock: 1,
                gender: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                raceOthers: null,
                race: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                }
            }
        }
    },
    validations: {
        form: {
            name: { required },
            rgRne: { required },
            cpf: { required, minLength: minLength(14) },
            birthday: { required },
            cell: { required, minLength: minLength(15) },
            email: { required, email }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress', 'setShowGamificationProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData

            this.form.name = data.nome_completo
            this.form.rgRne = data.rg
            this.form.cpf = data.cpf
            this.form.birthday = data.data_nascimento
            this.form.race.selected = data.id_raca
            this.form.raceOthers = data.raca_outros
            this.form.gender.selected = data.id_genero
            this.form.cell = data.celular
            this.form.cellLock = data.view_celular
            this.form.email = data.email
            this.form.emailLock = data.view_email
            this.form.linkedin = data.linkedin
            this.form.linkedinLock = data.view_linkedin
            this.form.rgLock = data.view_rg
            this.form.cpfLock = data.view_cpf
            this.form.birthdayLock = data.view_data_nascimento
            this.form.genderLock = data.view_genero
            this.form.raceLock = data.view_raca

            this.setIsLoading(true)

            axios
                .all([aboutLegalGuardianApi.getGender(), aboutLegalGuardianApi.getRace()])
                .then(response => {
                    this.form.gender.options.push(
                        ...response[0].data.map(item => ({ value: item.id, text: item.genero }))
                    )

                    this.form.race.options.push(...response[1].data.map(item => ({ value: item.id, text: item.raca })))

                    this.fetchAuthorization()
                })
                .finally(() => this.setIsLoading(false))
        },
        fetch() {
            if (this.getProgress === '8.31') {
                this.setShowGamificationProgress(true)

                setTimeout(() => {
                    this.setShowGamificationProgress(false)
                }, 12000)
            }

            this.usuario = JSON.parse(localStorage.getItem('usuario'))
            this.setIsLoading(true)

            axios
                .all([
                    aboutLegalGuardianApi.getLegalGuardian(),
                    aboutLegalGuardianApi.getGender(),
                    aboutLegalGuardianApi.getRace()
                ])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.legalGuardianData = data
                        this.form.name = data.nome_completo
                        this.form.rgRne = data.rg
                        this.form.cpf = data.cpf
                        this.form.birthday = data.data_nascimento
                        this.form.race.selected = data.id_raca
                        this.form.raceOthers = data.raca_outros
                        this.form.gender.selected = data.id_genero
                        this.form.cell = data.celular
                        this.form.cellLock = data.view_celular
                        this.form.email = data.email
                        this.form.emailLock = data.view_email
                        this.form.linkedin = data.linkedin
                        this.form.linkedinLock = data.view_linkedin
                        this.form.rgLock = data.view_rg === null ? 1 : data.view_rg
                        this.form.cpfLock = data.view_cpf === null ? 1 : data.view_cpf
                        this.form.birthdayLock = data.view_data_nascimento === null ? 1 : data.view_data_nascimento
                        this.form.genderLock = data.view_genero === null ? 1 : data.view_genero
                        this.form.raceLock = data.view_raca === null ? 1 : data.view_raca

                        this.setProgress(data.percentual)
                    }

                    this.form.gender.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.genero }))
                    )

                    this.form.race.options.push(...response[2].data.map(item => ({ value: item.id, text: item.raca })))
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit() {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress

            const data = this.isUpdate
                ? {
                      ...this.legalGuardianData,
                      nome_completo: this.form.name,
                      rg: this.form.rgRne,
                      cpf: this.form.cpf,
                      data_nascimento: this.form.birthday,
                      id_raca: this.form.race.selected,
                      raca_outros: this.form.raceOthers,
                      id_genero: this.form.gender.selected,
                      celular: this.form.cell,
                      view_celular: this.form.cellLock,
                      email: this.form.email,
                      view_email: this.form.emailLock,
                      linkedin: this.form.linkedin,
                      view_linkedin: this.form.linkedinLock,
                      view_rg: this.form.rgLock,
                      view_cpf: this.form.cpfLock,
                      view_data_nascimento: this.form.birthdayLock,
                      view_genero: this.form.genderLock,
                      view_raca: this.form.raceLock,
                      percentual: currentProgress
                  }
                : {
                      nome_completo: this.form.name,
                      rg: this.form.rgRne,
                      cpf: this.form.cpf,
                      data_nascimento: this.form.birthday,
                      id_raca: this.form.race.selected,
                      raca_outros: this.form.raceOthers,
                      id_genero: this.form.gender.selected,
                      celular: this.form.cell,
                      view_celular: this.form.cellLock,
                      email: this.form.email,
                      view_email: this.form.emailLock,
                      linkedin: this.form.linkedin,
                      view_linkedin: this.form.linkedinLock,
                      view_rg: this.form.rgLock,
                      view_cpf: this.form.cpfLock,
                      view_data_nascimento: this.form.birthdayLock,
                      view_genero: this.form.genderLock,
                      view_raca: this.form.raceLock,
                      percentual: currentProgress
                  }

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutLegalGuardianApi.updateLegalGuardian(data)
                : aboutLegalGuardianApi.createLegalGuardian(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.isUpdate
                        ? this.changeStatusDisabled(true)
                        : this.$router.push({ name: 'AboutLegalGuardianForm2' })
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getLegalGuardian(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getMajorityDate() {
            const d = new Date()
            return `${d.getFullYear() - 18}-${d.getMonth() + 1}-${d.getDate()}`
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutLegalGuardianForm1-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-legal-guardian/AboutLegalGuardianForm1.vue